export enum Steps {
    apk = 1,
    questionsToOffer,
    offerCustomizer,
    contractData,
    thankYouPage,
    proxiesExceeded,
    authorizationForRenewal
}
